export function normalizePhone(phone?: string): string | undefined {
  if (!phone) return undefined
  const digits = phone.replace(/\D/g, '')

  if (digits.length === 11) {
    return `55${digits}`
  }

  if (digits.length >= 13) {
    return digits
  }

  return undefined
}
